import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'

import ProductPagination from './components/productPagination'
import ProductPrices from './components/productPrices'
import ProductDescription from './components/productDescription'
import ProductCtas from '../ProductCtas/ProductDetailsCta'
import ProductCustomLabel from './components/productCustomLabel'
import ProductAvailability from './components/productAvailability'
import LoadingSkeleton from '../../Generics/LoadingSkeleton'
import ProductName from '../ProductName'
import { selectProduct } from '../../../../flux/selectors/product'

const StyledRoot = styled.div(({ theme: { spaces, colors } }) => ({
  backgroundColor: colors.light_grey,
  paddingBottom: spaces.default / 2,
  paddingTop: spaces.default / 2,
}))

const StyledInfo = styled.div(({ theme: { spaces } }) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  maxWidth: '500px',
  position: 'relative',
  padding: `${spaces.default}px ${spaces.default / 2}px 0`,
}))

const StyledInfoHeader = styled.div(() => ({
  display: 'flex',
}))

const StyledInfoHeaderSubtitle = styled.div(() => ({
  flex: '0 0 auto',
}))

const ProductDetailSkelton = () => (
  <StyledRoot>
    <StyledInfo>
      <LoadingSkeleton height="30px" margin="10px 0" reverse />
      <LoadingSkeleton height="100px" reverse />
    </StyledInfo>
  </StyledRoot>
)

const ProductDetail = ({
  productId,
  hideProductsTitle,
  descriptionLabel,
  name,
  sale,
  price,
  prefixPrice,
  suffixPrice,
  customLabel,
  discountedPrice,
  description,
  onSeeMoreClick,
  availability,
  pagination,
  containerRef,
}) => {
  const product = useSelector(selectProduct(productId))

  if (!productId || !product) {
    return (<ProductDetailSkelton />)
  }

  return (
    <StyledRoot>
      <StyledInfo>
        <StyledInfoHeader>
          <ProductName
            name={name}
            hideProductsTitle={hideProductsTitle}
          />
          <StyledInfoHeaderSubtitle>
            {pagination && (
              <ProductPagination>{pagination}</ProductPagination>
            )}
          </StyledInfoHeaderSubtitle>
        </StyledInfoHeader>
        <ProductPrices
          price={price}
          prefixPrice={prefixPrice}
          suffixPrice={suffixPrice}
          discountedPrice={discountedPrice}
          sale={sale}
        />
        {customLabel ? (<ProductCustomLabel>{customLabel}</ProductCustomLabel>) : null}
        {availability ? (<ProductAvailability availability={availability} />) : null}
        <ProductCtas productId={productId} />
      </StyledInfo>
      {description
        && (
          <ProductDescription
            productId={productId}
            description={description}
            onSeeMoreClick={onSeeMoreClick}
            descriptionLabel={descriptionLabel}
            containerRef={containerRef}
          />
        )}
    </StyledRoot>
  )
}

ProductDetail.propTypes = {
  productId: PropTypes.string,
  hideProductsTitle: PropTypes.bool,
  availability: PropTypes.string,
  descriptionLabel: PropTypes.string,
  name: PropTypes.string,
  sale: PropTypes.string,
  price: PropTypes.string,
  prefixPrice: PropTypes.string,
  suffixPrice: PropTypes.string,
  discountedPrice: PropTypes.string,
  customLabel: PropTypes.string,
  description: PropTypes.string,
  pagination: PropTypes.string,
  onSeeMoreClick: PropTypes.func,
  containerRef: PropTypes.shape({}),
}

ProductDetail.defaultProps = {
  productId: undefined,
  hideProductsTitle: false,
  availability: '',
  descriptionLabel: '',
  name: '',
  sale: '',
  price: '',
  prefixPrice: '',
  suffixPrice: '',
  discountedPrice: '',
  customLabel: '',
  description: '',
  pagination: '',
  onSeeMoreClick: () => false,
  containerRef: null,
}

ProductDetail.displayName = 'ProductDetail'
ProductDetail.whyDidYouRender = true

export default ProductDetail
